import { request, gql } from '@mrkt/features/graphql-client';

import {
  GetArtistsByUrisQuery,
  GetArtistsByUrisQueryVariables,
} from '@mrkt/features/graphql-types';

const query = gql`
  query GetArtistsByUris($ids: [String!]!) {
    artists(ids: $ids) {
      id
      imageUrl
      name
      uri
    }
  }
`;

export function getArtistsByUris(variables: GetArtistsByUrisQueryVariables) {
  return request<GetArtistsByUrisQuery>(query, variables);
}
